
export default (props) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="69.125 3.583 71.521 188.917"
            xmlSpace="preserve"
            {...props}
        >
            <g fill={props.color}>
                <path d="m105 3.74 35.56 35.65L105 75.04 69.44 39.39zM133.27 81.76c4.471 2.98 5.66 20.29 5.66 20.29s-1.189 17.31-5.66 20.29c-4.46 2.98-28.27 4.77-28.27 4.77s-23.81-1.79-28.27-4.77c-4.47-2.98-5.66-20.29-5.66-20.29s1.19-17.31 5.66-20.29c4.46-2.98 28.27-4.77 28.27-4.77s23.81 1.79 28.27 4.77zM105 130.69c16.77 0 30.36 13.62 30.36 30.44 0 16.81-13.591 30.43-30.36 30.43-16.77 0-30.36-13.62-30.36-30.43 0-16.82 13.59-30.44 30.36-30.44z" />
            </g>
        </svg>
    );
}